import { DataPath } from '../../DataPath';
import { ParseNode } from '../../Parse/ParseNode';
import { ExprForm } from '../ExprForm';
import { ExprPath } from '../ExprPath';
import { Generic } from './Generic';
export var Access;
(function (Access) {
    function matches(root) {
        return ParseNode.isAccess(root);
    }
    Access.matches = matches;
    function parse(root) {
        switch (root.type) {
            case "Identifier":
            case "AccessIdentifier":
            case "AccessExpression": {
                const path = ExprPath.fromParseNode(root);
                if (path.type !== "EMPTY") {
                    return Parsed.make(root, path);
                }
            }
        }
        return Generic.Parsed.make(root);
    }
    Access.parse = parse;
    let Parsed;
    (function (Parsed) {
        function make(root, path) {
            const form = ExprForm.Access;
            const state = "PARSED";
            const name = DataPath.name(path);
            return { root, path, state, form, name };
        }
        Parsed.make = make;
    })(Parsed = Access.Parsed || (Access.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(expr, stage, data) {
            const name = stage === "AGGREGATE" ? `AGG(${expr.name})` : expr.name;
            return { ...expr, name, stage, data, state: "COMPILED" };
        }
        Compiled.make = make;
    })(Compiled = Access.Compiled || (Access.Compiled = {}));
})(Access || (Access = {}));
